import axios from "axios";
import { toast } from "react-toastify";
import i18n from "../../i18n";
import { MULTIPLIER, PDA_PREFIX } from "../../global/constants";
import logoutforSpecificErrorCodes from "../../securityUtils/LogoutUtils";
import { combineBlocksAndDepdencies } from "../../utils/DependencyUtils/DependencyUtils";
import { logout } from "../security-services/SecurityActions";
import {
  GET_ERRORS,
  GET_BLOCK,
  DELETE_BLOCK,
  UPDATE_BLOCKS_REQUEST,
  UPDATE_BLOCKS_ERROR,
  GET_BLOCKS_REQUEST,
  GET_BLOCKS_SUCCESS,
  GET_BLOCKS_ERROR,
  GET_BLOCKS_SUBFLOW_REQUEST,
  GET_BLOCKS_SUBFLOW_SUCCESS,
  GET_BLOCKS_SUBFLOW_ERROR,
  GET_FAVORITE_BLOCKS_SUCCESS,
  GET_FAVORITE_BLOCKS_ERROR,
  GET_FAVORITE_BLOCKS_REQUEST,
  MOVE_BLOCK_REQUEST,
  MOVE_BLOCK_SUCCESS,
  MOVE_BLOCK_ERROR,
  MOVE_BLOCK_FAVORITE_SUCCESS,
  MOVE_BLOCK_FAVORITE_REQUEST,
  MOVE_BLOCK_FAVORITE_ERROR,
  COPY_BLOCKS_REQUEST,
  COPY_BLOCKS_SUCCESS,
  CLEAR_BLOCK,
  CLEAR_BLOCKS,
  CLEAR_BLOCKS_WITH_SUBFLOW,
  GET_BLOCKS_DEPS_REQUEST,
  GET_BLOCKS_DEPS_SUCCESS,
  GET_BLOCKS_DEPS_ERROR,
  ADD_BLOCK_REQUEST,
  ADD_BLOCK_SUCCESS,
  ADD_BLOCK_ERROR,
  UPDATE_BLOCK_REQUEST,
  UPDATE_BLOCK_SUCCESS,
  UPDATE_BLOCK_ERROR,
  UPDATE_BLOCK_DATA_REQUEST,
  UPDATE_BLOCK_DATA_SUCCESS,
  UPDATE_BLOCK_DATA_ERROR,
  UPDATE_BLOCK_PROGRESS_REQUEST,
  UPDATE_BLOCK_PROGRESS_SUCCESS,
  UPDATE_BLOCK_PROGRESS_ERROR,
  UPDATE_BLOCKS_SUCCESS,
  CONVERT_BLOCK_ACTIVITY_TO_BLOCK,
  UPDATE_BLOCK_ACTIVITY,
  GET_GRID_BLOCKS_REQUEST,
  GET_GRID_BLOCKS_SUCCESS,
  DELETE_BLOCK_ON_MAPPING_GRID,
  UPDATE_NAME_ON_MAPPING_GRID,
  ADD_RECORD_ON_MAPPING_GRID,
  PUSH_BLOCK_ONTO_MAPPING_SUBFLOW,
  START_BLOCK_STREAMING,
  STOP_BLOCK_STREAMING,
  UPDATE_BLOCK_PROPERTIES,
} from "../types";

const createBlockRequest = () => ({ type: ADD_BLOCK_REQUEST });
const createBlockSuccess = (data) => ({
  type: ADD_BLOCK_SUCCESS,
  payload: data,
});
const createBlockError = (err) => ({
  type: ADD_BLOCK_ERROR,
  payload: err,
});

const updateBlockRequest = () => ({ type: UPDATE_BLOCK_REQUEST });
const updateBlockSuccess = (block) => ({
  type: UPDATE_BLOCK_SUCCESS,
  payload: block,
});
const updateBlockError = (err) => ({
  type: UPDATE_BLOCK_ERROR,
  payload: err,
});

const updateBlockDataRequest = () => ({ type: UPDATE_BLOCK_DATA_REQUEST });
const updateBlockDataSuccess = (data) => ({
  type: UPDATE_BLOCK_DATA_SUCCESS,
  payload: data,
});
const updateBlockDataError = (err) => ({
  type: UPDATE_BLOCK_DATA_ERROR,
  payload: err,
});

const updateBlockProgressRequest = () => ({
  type: UPDATE_BLOCK_PROGRESS_REQUEST,
});
const updateBlockProgressSuccess = (data) => ({
  type: UPDATE_BLOCK_PROGRESS_SUCCESS,
  payload: data,
});
const updateBlockProgressError = (err) => ({
  type: UPDATE_BLOCK_PROGRESS_ERROR,
  payload: err,
});

const getBlocksRequest = () => ({ type: GET_BLOCKS_REQUEST });
const getBlocksSuccess = (blocks, accumulate) => ({
  type: GET_BLOCKS_SUCCESS,
  payload: { blocks, accumulate },
});
const getBlocksError = (err) => ({
  type: GET_BLOCKS_ERROR,
  payload: err,
});

const getBlocksSubflowRequest = (accumulate) => ({
  type: GET_BLOCKS_SUBFLOW_REQUEST,
  payload: { accumulate },
});
const getBlocksSubflowSuccess = (blocks, parentId, accumulate) => ({
  type: GET_BLOCKS_SUBFLOW_SUCCESS,
  payload: { blocks, parentId, accumulate },
});
const getBlocksSubflowError = (err) => ({
  type: GET_BLOCKS_SUBFLOW_ERROR,
  payload: err,
});

const getBlocksWithDependenciesRequest = () => ({
  type: GET_BLOCKS_DEPS_REQUEST,
});
const getBlocksWithDependenciesSuccess = (blocks) => ({
  type: GET_BLOCKS_DEPS_SUCCESS,
  payload: blocks,
});
const getBlocksWithDependencieError = (err) => ({
  type: GET_BLOCKS_DEPS_ERROR,
  payload: err,
});

const getFavoriteBlocksRequest = () => ({ type: GET_FAVORITE_BLOCKS_REQUEST });
const getFavoriteBlocksSuccess = (blocks) => ({
  type: GET_FAVORITE_BLOCKS_SUCCESS,
  payload: blocks,
});
const getFavoriteBlocksError = (err) => ({
  type: GET_FAVORITE_BLOCKS_ERROR,
  payload: err,
});

const moveBlockRequest = () => ({ type: MOVE_BLOCK_REQUEST });
const moveBlockSuccess = (coords) => ({
  type: MOVE_BLOCK_SUCCESS,
  payload: coords,
});

const copyBlocksRequest = () => ({ type: COPY_BLOCKS_REQUEST });
const copyBlocksSuccess = (blocks) => ({
  type: COPY_BLOCKS_SUCCESS,
  payload: blocks,
});

const moveBlockError = (err) => ({
  type: MOVE_BLOCK_ERROR,
  payload: err,
});

const moveBlockFavoriteRequest = () => ({ type: MOVE_BLOCK_FAVORITE_REQUEST });
const moveBlockFavoriteSuccess = (coords) => ({
  type: MOVE_BLOCK_FAVORITE_SUCCESS,
  payload: coords,
});
const moveBlockFavoriteError = (err) => ({
  type: MOVE_BLOCK_FAVORITE_ERROR,
  payload: err,
});

export const updateBlocksRequest = () => ({ type: UPDATE_BLOCKS_REQUEST });
export const updateBlocksSuccess = (blocks) => ({
  type: UPDATE_BLOCKS_SUCCESS,
  payload: blocks,
});

export const updateBlocksError = (error) => ({
  type: UPDATE_BLOCKS_ERROR,
  payload: error,
});

export const convertBlockActivityToBlock = (id) => ({
  type: CONVERT_BLOCK_ACTIVITY_TO_BLOCK,
  payload: id,
});

export const updateBlockActivity = (activity) => ({
  type: UPDATE_BLOCK_ACTIVITY,
  payload: activity,
});

export const createBlock = (block, structureId) => async (dispatch) => {
  // dispatch(createBlockRequest());
  try {
    const res = await axios.post(`${PDA_PREFIX}/block/${structureId}`, block);
    dispatch(createBlockSuccess({ block: res.data }));
    toast.success(`${i18n.t("term.block")} created!`);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
  } catch (err) {
    dispatch(createBlockError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error("Invalid request. Please follow instructions.");
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
  }
};

export const createStructureBlock = (block, structureId) => async (
  dispatch
) => {
  // dispatch(createBlockRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/block/structure/${structureId}`,
      block
    );
    dispatch(createBlockSuccess({ block: res.data }));
    toast.success(`${i18n.t("term.block")} created!`);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
  } catch (err) {
    dispatch(createBlockError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error("Invalid request. Please follow instructions.");
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
  }
};

export const createDefaultBlock = (
  structureId,
  parentId,
  blockType,
  accumulate = false
) => async (dispatch) => {
  // dispatch(createBlockRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/block/default/${structureId}/${parentId}`
    );
    if (parentId === structureId && !res.data.parentId) {
      res.data.parentId = structureId;
    }
    dispatch(createBlockSuccess({ block: res.data, blockType, accumulate }));
    const blockToAddOnMappingGrid = {
      id: res.data.id,
      name: res.data.name,
      rowIndex: res.data.uxId,
      type: "BLOCK",
      block: true,
      activity: false,
      children: [],
    };
    dispatch({
      type: ADD_RECORD_ON_MAPPING_GRID,
      payload: {
        parentId: parseInt(parentId),
        record: blockToAddOnMappingGrid,
      },
    });
    toast.success(`${i18n.t("term.block")} created!`);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
  } catch (err) {
    dispatch(createBlockError(err));
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error("Something went wrong");
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
  }
};

export const updateBlock = (block, id) => async (dispatch) => {
  dispatch(updateBlockRequest());
  try {
    const res = await axios.put(`${PDA_PREFIX}/block/${id}`, block);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
    dispatch(updateBlockSuccess(res.data));
  } catch (err) {
    toast.error(err.response.data);
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateBlockError(err));
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
  }
};

export const updateBlockData = (data, updateStore = true) => async (
  dispatch
) => {
  updateStore && dispatch(updateBlockDataRequest());
  try {
    await axios.patch(`${PDA_PREFIX}/block/mapping/update`, data);
    updateStore &&
      dispatch({
        type: GET_ERRORS,
        payload: {},
      });
    updateStore && dispatch(updateBlockDataSuccess(data));
  } catch (err) {
    toast.error(err.response.data);
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    updateStore && dispatch(updateBlockDataError(err));
    updateStore &&
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
  }
};

export const updateBlockName = (data) => async (dispatch) => {
  dispatch(updateBlockDataSuccess(data));
  dispatch({
    type: UPDATE_NAME_ON_MAPPING_GRID,
    payload: {
      id: parseInt(data.id),
      name: data.name,
    },
  });
  try {
    await axios.patch(`${PDA_PREFIX}/block/mapping/name-update`, data);
  } catch (err) {
    toast.error(err.response.data);
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateBlockDataError(err));
  }
};

export const updateBlockCode = (data) => async (dispatch) => {
  try {
    await axios.patch(`${PDA_PREFIX}/block/mapping/code-update`, data);
    dispatch(updateBlockDataSuccess(data));
  } catch (err) {
    toast.error("Something went wrong");
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateBlockDataError(err));
  }
};

export const updateBlockProgress = (data) => async (dispatch) => {
  dispatch(updateBlockProgressRequest());
  try {
    await axios.post(`${PDA_PREFIX}/block/compute-progress`, data);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
    dispatch(updateBlockProgressSuccess(data));
    return true;
  } catch (err) {
    toast.error(err.response.data);
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateBlockProgressError(err));
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
    return false;
  }
};

export const updateBlockNoValidation = (block, id) => async (dispatch) => {
  try {
    await axios.put(`${PDA_PREFIX}/block/no-validation/${id}`, block);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
  } catch (err) {
    toast.error(err.response.data);
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
  }
};

export const updateAllBlocks = (blocks) => async (dispatch) => {
  //dispatch(updateBlocksRequest());
  try {
    const res = await axios.put(`${PDA_PREFIX}/block/update-all`, blocks);
    dispatch(updateBlocksSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateBlocksError(err));
  }
};

export const updateBlocksDimension = (blocks, structureIdentifier) => async (
  dispatch
) => {
  //dispatch(updateBlocksRequest());
  try {
    const res = await axios.patch(
      `${PDA_PREFIX}/block/update-dimensions/${structureIdentifier}`,
      blocks
    );
    dispatch(updateBlocksSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(updateBlocksError(err));
  }
};

export const copyAllBlocks = (blocks, structureId) => async (dispatch) => {
  //dispatch(copyBlocksRequest());
  try {
    const res = await axios.post(
      `${PDA_PREFIX}/block/copy-all/${structureId}`,
      blocks
    );
    //dispatch(copyBlocksSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    //dispatch(updateBlocksError(err));
  }
};

export const updateFavoriteBlock = (block) => async (dispatch) => {
  try {
    await axios.put(`${PDA_PREFIX}/block/update-favorite`, block);
    dispatch({
      type: GET_ERRORS,
      payload: {},
    });
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    toast.error(err.response.data);
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    });
  }
};

export const getAllBlocks = (id, accumulate = false) => async (dispatch) => {
  dispatch(getBlocksRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/block/all/${id}`);
    dispatch(getBlocksSuccess(res.data, accumulate));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getBlocksError(err));
  }
};

export const getBlocksWithSubflow = (id, accumulate = false) => async (
  dispatch
) => {
  dispatch(getBlocksSubflowRequest(accumulate));
  try {
    const res = await axios.get(`${PDA_PREFIX}/block/${id}/subflow`);
    res.data.forEach((item) => (item.data.structureId = id));
    dispatch(getBlocksSubflowSuccess(res.data, id, accumulate));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getBlocksSubflowError(err));
  }
};

export const getAllInterfacablePortfolioBlocks = () => async (dispatch) => {
  dispatch(getBlocksSubflowRequest());
  try {
    const res = await axios.get(
      `${PDA_PREFIX}/block/all-interfacable/portfolio`
    );
    dispatch(getBlocksSubflowSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getBlocksSubflowError(err));
  }
};

export const getBlocksWithDependencies = (id) => async (dispatch) => {
  dispatch(getBlocksWithDependenciesRequest());
  dispatch(getBlocksRequest());
  try {
    const resblocks = await axios.get(`${PDA_PREFIX}/block/all/${id}`);
    const resDeps = await axios.get(`${PDA_PREFIX}/dependency/${id}`);
    const blocksWithDeps = combineBlocksAndDepdencies(
      resblocks.data.filter((block) => block.attributeType === MULTIPLIER),
      resDeps.data
    );
    dispatch(
      getBlocksSuccess(
        resblocks.data.filter((block) => block.attributeType === MULTIPLIER)
      )
    );
    dispatch(getBlocksWithDependenciesSuccess(blocksWithDeps));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getBlocksWithDependencieError(err));
  }
};

export const getAllPortfolioBlocks = () => async (dispatch) => {
  dispatch(getFavoriteBlocksRequest());
  try {
    const res = await axios.get(`${PDA_PREFIX}/block/all/portfolio`);
    dispatch(getFavoriteBlocksSuccess(res.data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
    dispatch(getFavoriteBlocksError(err));
  }
};

export const getBlock = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`${PDA_PREFIX}/block/${id}`);

    dispatch({
      type: GET_BLOCK,
      payload: res.data,
    });
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const moveBlock = (data) => async (dispatch) => {
  // dispatch(moveBlockRequest());
  try {
    const res = await axios.patch(`${PDA_PREFIX}/block/move-item`, data);
    // dispatch(moveBlockSuccess(res.data));
  } catch ({ message }) {
    dispatch(moveBlockError(message));
  }
};

export const moveBlockFavorite = (data) => async (dispatch) => {
  //dispatch(moveBlockFavoriteRequest());
  try {
    const res = await axios.patch(`${PDA_PREFIX}/block/move-favorite`, data);
    // dispatch(moveBlockFavoriteSuccess(res.data));
  } catch ({ message }) {
    dispatch(moveBlockFavoriteError(message));
  }
};

export const deleteBlock = (blockId) => async (dispatch) => {
  try {
    const res = await axios.delete(`${PDA_PREFIX}/block/${blockId}`);
    dispatch({
      type: DELETE_BLOCK,
      payload: res.data,
    });
    dispatch({
      type: DELETE_BLOCK_ON_MAPPING_GRID,
      payload: parseInt(blockId),
    });
    toast.success(`${i18n.t("term.block")} deleted`);
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const clearBlock = () => async (dispatch) => {
  dispatch({ type: CLEAR_BLOCK });
};

export const clearBlocks = () => async (dispatch) => {
  dispatch({
    type: CLEAR_BLOCKS,
    payload: [],
  });
};

export const clearBlocksWithSubflow = () => async (dispatch) => {
  dispatch({
    type: CLEAR_BLOCKS_WITH_SUBFLOW,
    payload: [],
  });
};

export const deleteAllBlock = (id) => async (dispatch) => {
  try {
    await axios.delete(`${PDA_PREFIX}/block/${id}`);
    dispatch({
      type: DELETE_BLOCK,
      payload: id,
    });
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

const getGridBlocksRequest = () => ({
  type: GET_GRID_BLOCKS_REQUEST,
});

const getGridBlocksSuccess = (data) => ({
  type: GET_GRID_BLOCKS_SUCCESS,
  payload: data,
});

export const getMappingGridBlocks = (structureId) => async (dispatch) => {
  dispatch({ type: GET_GRID_BLOCKS_REQUEST });
  try {
    const { data } = await axios.get(
      `${PDA_PREFIX}/block/mapping/${structureId}/all`
    );
    dispatch(getGridBlocksSuccess(data));
  } catch (err) {
    if (logoutforSpecificErrorCodes(err)) {
      dispatch(logout());
    }
  }
};

export const updateBlockProperties = (payload) => async (dispatch) => {
  try {
    await axios.post(`${PDA_PREFIX}/block/update/properties`, payload);
    dispatch({ type: UPDATE_BLOCK_PROPERTIES, payload });
    toast.success("Properties updated successfully !");
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong when updating block properties");
  }
}

/**
 * Push one block into `state.block.blocksSubflow` in response to a
 * BLOCK_CREATED WS frame emitted by ScopeImportAsyncService while the GW
 * "Generate scopes & structures" job is producing blocks. Live-paints the
 * Mapping tab canvas (`ScopeMappingView` → `ProcessMapping`) one node at a
 * time so the user can watch the structure build itself instead of waiting
 * for the terminal ALL_COMPLETED refetch. Payload is the wire shape from
 * `ScopeImportAsyncService#toBlockPayload`.
 */
export const pushBlockOntoMappingSubflow = (block) => ({
  type: PUSH_BLOCK_ONTO_MAPPING_SUBFLOW,
  payload: block,
});

/**
 * Dispatched from the GW page right before the "Generate scopes & structures"
 * async job kicks off. Clears blocksSubflow to a blank canvas and gates any
 * subsequent GET_BLOCKS_SUBFLOW request/success (from a late ScopeMappingView
 * mount) until the job's terminal frame lands. See `startBlockStreaming` +
 * `stopBlockStreaming` in the reducer for the guard logic.
 */
export const startBlockStreaming = () => ({ type: START_BLOCK_STREAMING });
export const stopBlockStreaming = () => ({ type: STOP_BLOCK_STREAMING }); 